import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { SERVICES } from "../data/services";
import { Logo, Wordmark } from "./Logo";
import { LOCATIONS } from "../data/locations";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-panel" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-12 lg:gap-x-8">
        <div className="sm:col-span-2 lg:col-span-4 min-w-0">
          <Link to="/" className="flex items-center gap-3" data-testid="footer-logo-link">
            <Logo className="h-16 w-16" />
            <Wordmark />
          </Link>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#C9D2DE]">
            Enterprise-grade IT, built for small business. A national service provider for companies of up to
            25 employees across the United States — small business specialists since 2015.
          </p>
          <p className="mt-6 flex items-start gap-2 text-sm leading-relaxed text-[#C9D2DE]" data-testid="footer-address">
            <MapPin size={15} className="mt-0.5 shrink-0 text-brand" />
            <span>
              1643 Warwick Ave, Suite 183
              <br />
              Warwick, RI 02889
            </span>
          </p>
          <p className="mt-4 text-xs leading-relaxed text-[#A8B4C2]">
            Each client is given the direct contact phone number to their assigned engineer. There are no support
            lines where you wait on hold for hours hoping someone will pick up soon.
          </p>
          <p className="mt-6 font-display text-xs font-bold uppercase tracking-[0.25em] text-[#A8B4C2]">
            Powered by <span className="text-brand">Huntress</span> · <span className="text-brand">MSP360</span> ·{" "}
            <span className="text-brand">Microsoft 365</span>
          </p>
        </div>
        <div className="lg:col-span-3 min-w-0">
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#A8B4C2]">Services</p>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid={`footer-service-${s.slug}`}>
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-2 min-w-0">
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#A8B4C2]">Company</p>
          <ul className="mt-5 space-y-3">
            <li><Link to="/about" className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid="footer-about-link">About</Link></li>
            <li><Link to="/pricing" className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid="footer-pricing-link">Pricing</Link></li>
            <li><Link to="/contact" className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid="footer-contact-link">Contact</Link></li>
            <li><Link to="/contact?mode=book" className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid="footer-book-link">Book a consultation</Link></li>
            <li><Link to="/insights" className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid="footer-insights-link">Insights</Link></li>
            <li><Link to="/glossary" className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid="footer-glossary-link">IT Glossary</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-3 min-w-0">
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#A8B4C2]">New England</p>
          <ul className="mt-5 space-y-3">
            {LOCATIONS.map((l) => (
              <li key={l.slug}>
                <Link to={`/locations/${l.slug}`} className="text-sm text-[#C9D2DE] transition-colors duration-200 hover:text-brand" data-testid={`footer-location-${l.slug}`}>
                  {l.state}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-white/5 pt-8 md:flex-row md:flex-wrap md:items-center md:justify-between">
        <p className="text-xs text-zinc-600">© 2026 Sempresera. Managed IT for small business since 2015.</p>
        <div className="flex items-center gap-5">
          <Link to="/terms" className="text-xs text-zinc-600 transition-colors duration-200 hover:text-brand" data-testid="footer-terms-link">Terms of Service</Link>
          <Link to="/privacy" className="text-xs text-zinc-600 transition-colors duration-200 hover:text-brand" data-testid="footer-privacy-link">Privacy Policy</Link>
        </div>
        <p className="text-xs text-zinc-600">National services for small businesses across the United States.</p>
      </div>
    </div>
  </footer>
);
